$(function () {
    // Показ tooltip'ов с полным описанием товара
    $('[data-bs-toggle="tooltip"]').tooltip();

    // Запоминание закрытия уведомления
    $('[data-bs-dismiss]').click(function () {
        const id = $(this).closest('div').data('alertId').toString();

        if (id) {
            let ids = document.cookie
                .replace(/(?:(?:^|.*;\s*)closeAlert\s*\=\s*([^;]*).*$)|^.*$/, "$1")
                .split('+');

            if (ids.indexOf(id) === -1) {
                ids.push(id);
            }

            ids = ids.filter(value => !!value);

            document.cookie = 'closeAlert=' + ids.join('+') + '; path=/; max-age=2592000';
        }
    });

    // Работа с весами, ценами и заказом нужного веса
    $('.items-item-content-weights .badge').click(function () {
        let $this = $(this),
            $item = $this.parents('.items-item'),
            $buttons = $item.find('.items-item-content-buttons');

        let price = $this.data('price'),
            weight = $this.data('weight'),
            inBasket = $this.data('inBasket');

        $this.siblings('.bg-primary').removeClass('bg-primary');
        $this.addClass('bg-primary');

        $item.find('.items-item-content-price span').text(price);

        $buttons.data('currentWeight', weight).data('requestData', 'weight: ' + weight);

        if (inBasket) {
            $buttons.find('.add:not(.d-none)').addClass('d-none');
            $buttons.find('.added.d-none').removeClass('d-none');
        } else {
            $buttons.find('.add.d-none').removeClass('d-none');
            $buttons.find('.added:not(.d-none)').addClass('d-none');
        }
    });

    // Динамическое меню с разделами каталога
    let $nav = $('header .categories'),
        $btn = $nav.find('.hidden-links'),
        $vlinks = $nav.find('.visible-links'),
        $hlinks = $nav.find('.hidden-links .dropdown-menu');

    let numOfItems = 0,
        totalSpace = 0,
        breakWidths = [];

    // Get initial state
    $vlinks.children().outerWidth((i, w) => {
        totalSpace += w;
        numOfItems += 1;
        breakWidths.push(totalSpace);
    });

    let availableSpace, numOfVisibleItems, requiredSpace;

    function check() {
        // Get instant state
        availableSpace = $vlinks.width() - 10;
        numOfVisibleItems = $vlinks.children().length;
        requiredSpace = breakWidths[numOfVisibleItems - 1];

        // There is not enought space
        if (requiredSpace > availableSpace) {
            $vlinks.children().last().prependTo($hlinks);
            numOfVisibleItems -= 1;
            check();
            // There is more than enough space
        } else if (availableSpace > breakWidths[numOfVisibleItems]) {
            $hlinks.children().first().appendTo($vlinks);
            numOfVisibleItems += 1;
        }

        // Update the button accordingly
        if (numOfVisibleItems === numOfItems) {
            $btn.addClass('d-none');
        } else {
            $btn.removeClass('d-none');
        }
    }

    // Window listeners
    $(window).resize(function () {
        check();
    });

    check();
});

function toggleSubmitButton(enabled) {
    let $btn = $('#submit-request-button'),
        $text = $('#submit-request-text');

    if (enabled) {
        $btn.prop('disabled', null);
        $text.addClass('d-none');
    } else {
        $btn.prop('disabled', 'disabled');
        $text.removeClass('d-none');
    }
}

function onAfterAddedToBasket(element) {
    let $this = $(element),
        $item = $this.parents('.items-item'),
        $buttons = $item.find('.items-item-content-buttons');

    let weight = $buttons.data('currentWeight');

    $buttons.find('.add:not(.d-none)').addClass('d-none');
    $buttons.find('.added.d-none').removeClass('d-none');

    $item.find('.items-item-content-weights .badge[data-weight=' + weight + ']').data('inBasket', true);
}

function autoCloseModal(id) {
    setTimeout(() => {
        $(`#${id}Modal`).modal('hide');
        $(`#${id}Modal_forms_flash`).empty();
    }, 3000);
}
